import axios from 'axios';

export const LoginApi = {
  login: credentials => axios.post('/login', credentials),

  logout: accessToken =>
    axios.get('/logout', {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    }),

  getStringToSign: () => axios.get('/login/signature'),

  loginWithSign: data => axios.post('/login/signature', data),

  getUser: () => axios.get('/login'),

  getRequesterData: () => axios.get(`/api/self/requester`),
  zagsAutoFill: () => axios.put(`/api/self/requester/update_gbdfl_address`)
};
